const actions = {
  SET_STATE: 'videos/SET_STATE',
  GET_VIDEOS: 'videos/GET_VIDEOS',
  DELETE_VIDEO: 'videos/DELETE_VIDEO',

  RESET_STATE: 'videos/RESET_STATE',
}

export default actions
